/* 
 * Export component file to be used on project
*/

import ProfessionalChip from './ProfessionalChip.js';
export default ProfessionalChip;
